import { error, success } from 'redux/shelf';
import { select, put, takeEvery } from 'redux-saga/effects';
import { path } from 'ramda';
import capitalize from 'lodash/capitalize';
import { actions as notifications } from 'modules/notifications';
import { actions } from './index';

const getType = path<string>(['meta', 'type'])

function* watchDisableSuccess() {
  yield takeEvery(actions.disable, function* (action) {
    const type = getType(action);
    yield put(notifications.create({
      text: `${capitalize(type)} integration disabled successfully!`,
      type: 'success',
    }));
  });
}

function* watchUpdateSuccess() {
  yield takeEvery(actions.updateStamped, function* (action) {
    yield put(notifications.create({
      text: `Stamped.io integration updated successfully!`,
      type: 'success',
      timeout: 5000,
    }));
  });
  yield takeEvery(actions.updateYotpo, function* (action) {
    yield put(notifications.create({
      text: `Yotpo integration updated successfully!`,
      type: 'success',
      timeout: 5000,
    }));
  });
}

export default [
  watchDisableSuccess(),
  watchUpdateSuccess(),
];
